<template>
  <div class="container-fluid">
    <div class="col-10 offset-1 oil">
      <h2>Oleje i woski do desek, podłóg oraz mebli</h2>
      <p>
        Drewno to wyjątkowo piękny i szlachetny surowiec, ale wymaga starannej i
        odpowiedniej pielęgnacji, aby mogło cieszyć nas swoim wyglądem przez
        lata. W naszej ofercie znajdziecie Państwo oleje i woski do podłóg, a
        także do mebli, desek tarasowych i wielu innych drewnianych wyrobów,
        które przy stosowaniu właściwej konserwacji, będą nas cieszyć pięknym
        wyglądem przez lata. Oleje do desek doskonale je zabezpieczają, a przy
        okazji podkreślają też ich słoje i naturalny wygląd. Z kolei woski do
        podłóg to świetne utwardzacze, które ochronią je przed wilgocią i
        wzmocnią ich powierzchnię.
      </p>
      <p>
        W ofercie dostępne są też inne środki zabezpieczania drewna, takie jak
        lazura koloryzacyjna, która oprócz ochrony powierzchni, nada jej także
        piękną, nasyconą barwę, utrzymującą się przez długi czas.
      </p>
      <p>
        Serdecznie zapraszamy do nas aby wybrać idealny kolor dla siebie,
        delektując się pyszną kawą.
      </p>
      <p>Fachowe porady i zadowolenie z zakupu gwarantowane!</p>

      <div
        class="col-10 offset-1 oilType container-fluid"
        style="background-color:#fff"
      >
        <div v-scrollanimation>
          <b-img
            fluid
            alt="Responsive image"
            :src="require('../../assets/offer/olej1.jpg')"
          />
          <p>Wysokiej jakości lazury do elewacji i mebli ogrodowych</p>
        </div>
        <div v-scrollanimation>
          <b-img
            fluid
            alt="Responsive image"
            :src="require('../../assets/offer/olej2.jpg')"
          />
          <p>Naturalne olejo-woski do podłóg, blatów oraz mebli</p>
        </div>
        <div v-scrollanimation>
          <b-img
            fluid
            alt="Responsive image"
            :src="require('../../assets/offer/olej3.jpg')"
          />
          <p>Silnie zabezpieczające twarde woski do podłóg</p>
        </div>
        <div v-scrollanimation>
          <b-img
            fluid
            alt="Responsive image"
            :src="require('../../assets/offer/olej4.jpg')"
          />
          <p>Specjalistyczne oleje do tarasów</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.container-fluid {
  background-color: #eee;
}
.oil {
  background-color: #fff;
}
.oilType {
  display: flex;
  flex-direction: column;
}
.oilType div {
  margin: 2%;
}
.oil .oilType p {
  text-align: center;
}
.oil p,
.oil h2 {
  text-align: center;
}
.oil h2 {
  padding-top: 2%;
}
</style>
